import { RestreamDestinationsProps } from "./RestreamDestinationsTypes";
import { StyledRestreamDestinations, StyledTitle } from "./StyledComponents";
import { Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import RestreamDestinations from "./RestreamDestinations";

/**
 * Restream destinations tab for the legacy edit entry page.
 */
export const LegacyRestreamDestinations = (props: RestreamDestinationsProps) => {
    return (
        <StyledRestreamDestinations>
            <StyledTitle variant={"h4"}>{translate("Set Restream Destinations")}</StyledTitle>
            <Typography variant={"body2"}>
                {translate(
                    "Use restream to concurrently broadcast the event with additional streaming services such as social media."
                )}
            </Typography>
            <RestreamDestinations {...props} />
        </StyledRestreamDestinations>
    );
};
